<template>
  <div>
    <!-- 提交检品 -->
    <el-dialog :title="$t('message.organization')" :close-on-click-modal="false" :visible.sync="editDialog" center
      width="600px">
      <!-- 组织 -->
      <div class="selectBox">
        <label>{{ $t("message.organization") }} : </label>
        <cascader @setUserList="setUserList" :org_id="org_id"></cascader>
      </div>
      <div class="btns">
        <!-- 确认 -->
        <el-button type="primary" @click="confirm">{{
          $t("message.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editDialog: false,
      org_id: "",
    };
  },
  components: {},
  computed: {},
  created() {
    this.$store.dispatch("getOrganizationList");
  },
  methods: {
    open() {
      this.editDialog = true;
    },
    setUserList(data) {
      this.org_id = data.id;
    },
    // 确认修改
    confirm() {

      // 是否确认提交检品单
      this.$confirm(this.$t("message.confirmToSubmitTheInspectionList"), {
        type: "warning",
      })
        .then(() => {
          this.$api.inspectionApi
            .inspectSubmitInspect({
              inspect_sn: this.$parent.purchase.inspect_sn,
              org_id: this.org_id,
            })
            .then((res) => {
              this.$message.success(res.msg);
              this.editDialog = false;
              this.$parent.getData();
              this.$parent.checked = false;
            });
        })
        .catch(() => {
          //this.$message({
          //type: 'info',
          //message: '已取消删除'
          //});
        });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.selectBox {
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    margin-right: 10px;
  }
}

.btns {
  text-align: right;
}
</style>